import React, { useMemo } from 'react';
import { FaBook } from 'react-icons/fa';
import { activityPresets } from '../utils/activityLogger';
import '../styles/Capacitaciones.css';

// Helper para tema visual
export const getThemeForCapacitacion = (cat) => {
  const themes = [
    {
      gradientClass: 'cap-card-gradient-magenta',
      accentColor: '#b4007a',
      avatarBg: 'cap-card-avatar-magenta',
      chipBg: 'cap-card-chip-magenta',
    },
    {
      gradientClass: 'cap-card-gradient-blue',
      accentColor: '#0074d9',
      avatarBg: 'cap-card-avatar-blue',
      chipBg: 'cap-card-chip-blue',
    },
    {
      gradientClass: 'cap-card-gradient-green',
      accentColor: '#00b894',
      avatarBg: 'cap-card-avatar-green',
      chipBg: 'cap-card-chip-green',
    },
  ];
  let idx = typeof cat.id === 'number' ? cat.id % 3 : null;
  if (idx === null) {
    // fallback: hash nombre
    if (cat.nombre) {
      idx = cat.nombre.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % 3;
    } else {
      idx = Math.floor(Math.random() * 3);
    }
  }
  return themes[idx];
};

const getInitials = (nombre = '') => {
  const parts = nombre.trim().split(' ');
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + (parts[1][0] || '')).toUpperCase();
};

const CapacitacionCard = ({ cat, modulosCount = 0, onClick }) => {
  const theme = useMemo(() => getThemeForCapacitacion(cat), [cat]);
  const initials = getInitials(cat.nombre);
  
  const handleClick = () => {
    // Log cuando el usuario hace clic en una categoría de capacitación
    activityPresets.view('capacitacion_categoria', cat.id, { 
      nombre: cat.nombre,
      rol_destinado: cat.rol_destinado_nombre 
    });
    onClick();
  };
  
  return (
    <div className="cap-card" onClick={handleClick} tabIndex={0} role="button">
      <div className={`cap-card__cover ${theme.gradientClass}`}> 
        <div className="cap-card-cover-blur" />
        <div className={`cap-card__avatar ${theme.avatarBg}`}> 
          <FaBook className="cap-card__avatar-icon" />
          <span className="cap-card__avatar-initials">{initials}</span>
        </div>
        <h3 className="cap-card__title">{cat.nombre}</h3>
      </div>
      <div className="cap-card__body">
        <p className="cap-card__desc" title={cat.descripcion}>{cat.descripcion || 'Sin descripción'}</p>
        <div className="cap-card__meta">
          <span className={`cap-chip ${theme.chipBg}`}>{cat.rol_destinado_nombre || 'Todos'}</span>
        </div>
        <button className="cap-btn" onClick={handleClick}>Ver módulos</button>
      </div>
    </div>
  );
};

export default CapacitacionCard;
